import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

export interface DayConceptExclusions {
  breakfastProvided: boolean
  lunchProvided: boolean
  dinnerProvided: boolean
  accommodationProvided: boolean
}

export const getCompanyPaidLabel = (exclusions: DayConceptExclusions): string | null => {
  const parts: string[] = []
  if (exclusions.breakfastProvided) {
    parts.push(i18n.t('expenses_v2.forms.germany_per_diem_modal.company_paid.breakfast'))
  }
  if (exclusions.lunchProvided) {
    parts.push(i18n.t('expenses_v2.forms.germany_per_diem_modal.company_paid.lunch'))
  }
  if (exclusions.dinnerProvided) {
    parts.push(i18n.t('expenses_v2.forms.germany_per_diem_modal.company_paid.dinner'))
  }
  if (exclusions.accommodationProvided) {
    parts.push(i18n.t('expenses_v2.forms.germany_per_diem_modal.company_paid.overnight'))
  }
  if (parts.length === 0) return null
  return `${i18n.t(
    'expenses_v2.forms.germany_per_diem_modal.company_paid.deduction_label'
  )}: ${parts.join(', ')}`
}

const toDateKey = (d: Date | string): string => {
  if (typeof d === 'string') return d.slice(0, 10)
  return moment(d).format('YYYY-MM-DD')
}

export const buildConceptExclusionsByDate = (
  concepts:
    | Array<{
        date: Date | string
        breakfastProvided?: boolean
        lunchProvided?: boolean
        dinnerProvided?: boolean
        accommodationProvided?: boolean
      }>
    | null
    | undefined
): Record<string, DayConceptExclusions> | undefined => {
  if (!concepts || concepts.length === 0) return undefined
  const map: Record<string, DayConceptExclusions> = {}
  for (const c of concepts) {
    map[toDateKey(c.date)] = {
      breakfastProvided: Boolean(c.breakfastProvided),
      lunchProvided: Boolean(c.lunchProvided),
      dinnerProvided: Boolean(c.dinnerProvided),
      accommodationProvided: Boolean(c.accommodationProvided),
    }
  }
  return map
}
